// extracted by mini-css-extract-plugin
module.exports = {"mapSection":"MapContainer_mapSection__12HtW","map":"MapContainer_map__2q4zI","mountainAbsolute":"MapContainer_mountainAbsolute__2_gIf","button":"MapContainer_button__1U1fY"};